import classNames from 'classnames';
import React from 'react';
import styles from './Choice.scss';

interface ChoiceProps {
    label: string;
    name: string;
    isChecked: boolean;
    value: string;
    tabIndex?: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Choice = ({ label, name, tabIndex, isChecked, onChange, value }: ChoiceProps) => {
    return (
        <label role="radio" className={classNames(styles.choice, {[styles['choice--is-checked']]: isChecked})}>
            <input
                className={styles.choice__input}
                type="radio"
                name={name}
                checked={isChecked}
                onChange={onChange}
                value={value}    
            />
            <span className={styles.choice__label}>{label}</span>
        </label>
    )
};

export default Choice;
